import Component from "../classes/Component";

export default class AnimationObserver extends Component {
  constructor() {
    super({});
    this.element = [...document.querySelectorAll("[data-components-observer]")];
    this.observer();
    this.init();
  }
  init() {
    if (this.element) {
      this.listenObserver();
    }
  }
  observer() {
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio >= 0.3) {
            this.imageScale(entry);
            this.imageClip(entry);
            this.imageFadein(entry);
            this.imageTranslate(entry);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );
  }
  listenObserver() {
    this.element.forEach((el) => {
      this.observer.observe(el);
    });
  }
  imageScale(entry) {
    const scaleImages = [
      ...entry.target.querySelectorAll("[data-components-scale]"),
    ];
    scaleImages.forEach((img) => {
      img.classList.add("css-scale");
    });
  }
  imageClip(entry) {
    const scaleImages = [
      ...entry.target.querySelectorAll("[data-components-boxclip]"),
    ];
    scaleImages.forEach((img) => {
      img.classList.add("css-box-clip");
    });
  }
  imageFadein(entry) {
    const scaleImages = [
      ...entry.target.querySelectorAll("[data-components-fadein]"),
    ];
    scaleImages.forEach((img) => {
      img.classList.add("css-fadein");
    });
  }
  imageTranslate(entry) {
    let currentdelay = 0;
    const scaleImages = [
      ...entry.target.querySelectorAll("[data-components-translateY]"),
    ];
    scaleImages.forEach((img) => {
      img.style.transitionDelay = `${currentdelay}s`;
      img.classList.add("css-translate");
      currentdelay += 0.1;
    });
  }
}
